import React, {
  FC,
  HTMLAttributes,
  ImgHTMLAttributes,
  LiHTMLAttributes,
} from 'react'

import cn from 'classnames'

import classes from './lists.module.scss'

export const Columns: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.columns, className)} {...rest}>
    {children}
  </div>
)

interface HalfWidthColumnProps extends HTMLAttributes<HTMLDivElement> {
  condense?: boolean
}

export const HalfWidthColumn: FC<HalfWidthColumnProps> = ({
  condense,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      classes.halfWidthColumn,
      { [classes.condense]: condense },
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

export const Image: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  className,
  ...rest
}) => <img className={cn(classes.image, className)} alt="" {...rest} />

interface ListProps extends HTMLAttributes<HTMLUListElement> {
  condense?: boolean
}

export const List: FC<ListProps> = ({
  condense,
  className,
  children,
  ...rest
}) => (
  <ul
    className={cn(
      classes.list,
      { [classes.listCondense]: condense },
      className
    )}
    {...rest}
  >
    {children}
  </ul>
)

interface ListColumnsProps extends HTMLAttributes<HTMLUListElement> {
  isThreeColumns?: boolean
  condense?: boolean
}

export const ListColumns: FC<ListColumnsProps> = ({
  isThreeColumns,
  condense,
  className,
  children,
  ...rest
}) => (
  <ul
    className={cn(
      classes.list,
      classes.listColumns,
      {
        [classes.threeColumns]: isThreeColumns,
        [classes.listCondense]: condense,
      },
      className
    )}
    {...rest}
  >
    {children}
  </ul>
)

export const ListParagraphSmall: FC<HTMLAttributes<HTMLParagraphElement>> = ({
  className,
  children,
  ...rest
}) => (
  <p className={cn(classes.listParagraphSmall, className)} {...rest}>
    {children}
  </p>
)

interface ListItemProps extends LiHTMLAttributes<HTMLLIElement> {
  smallMargin?: boolean
}

export const ListItem: FC<ListItemProps> = ({
  smallMargin,
  className,
  children,
  ...rest
}) => (
  <li
    className={cn(
      classes.listItem,
      { [classes.smallMargin]: smallMargin },
      className
    )}
    {...rest}
  >
    {children}
  </li>
)

export const ListFragment: FC<HTMLAttributes<HTMLSpanElement>> = ({
  className,
  children,
  ...rest
}) => (
  <span className={cn(classes.listFragment, className)} {...rest}>
    {children}
  </span>
)

export const CheckIcon: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  className,
  ...rest
}) => <img className={cn(classes.checkIcon, className)} alt="" {...rest} />
